
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/kerala/[assembly]",
      function () {
        return require("private-next-pages/elections/assembly-chunav/kerala/[assembly].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/kerala/[assembly]"])
      });
    }
  